import React, { useEffect, useRef } from 'react';

// Tipado global
declare global {
    interface Window {
        miraiCore: any;
    }
}

interface MiraiBookingProps {
    hotelId?: string;
    isVertical?: boolean;
}

const MiraiBooking: React.FC<MiraiBookingProps> = ({ hotelId = '100376918', isVertical = false }) => {
    const containerRef = useRef<HTMLDivElement>(null);

    // --- CONFIGURACIÓN FIJA (Hardcoded) ---
    const FIXED_LOCALE = 'en-US'; // Siempre inglés

    // Generamos un ID estático, ya no necesitamos cambiarlo
    const CONTAINER_ID = 'mirai-widget-container';
    const SCRIPT_ID = 'mirai-core-script';

    useEffect(() => {
        const SCRIPT_URL = 'https://static.mirai.com/core/index.js';
        const CSS_URL = 'https://static.mirai.com/core/index.css';

        // 1. Cargar CSS
        if (!document.querySelector(`link[href="${CSS_URL}"]`)) {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = CSS_URL;
            document.head.appendChild(link);
        }

        // 2. Función de inicio simple
        const initWidget = () => {
            // Un pequeño delay para asegurar que el DOM está listo
            setTimeout(() => {
                if (window.miraiCore && containerRef.current) {
                    console.log("🚀 Mirai Widget Loaded (Fixed English)");
                    try {
                        window.miraiCore.init({
                            selector: `#${CONTAINER_ID}`,
                            hotelId: hotelId,
                            language: FIXED_LOCALE, // Fijo
                            layout: isVertical ? 'vertical' : 'horizontal'
                        });
                    } catch (e) {
                        console.error("Error init Mirai:", e);
                    }
                }
            }, 100);
        };

        // 3. Cargar script (Singleton pattern standard)
        const script = document.createElement('script');
        script.id = SCRIPT_ID;
        script.src = SCRIPT_URL;
        script.async = true;
        script.onload = initWidget;
        document.body.appendChild(script);

        // YA NO NECESITAMOS 'CLEANUP' PORQUE NO CAMBIARÁ
    }, [hotelId, isVertical]);

    return (
        <div
            ref={containerRef}
            id={CONTAINER_ID}
            className="mirai-core-wrapper"
            style={{
                minHeight: '120px',
                minWidth: isVertical ? '300px' : 'fit-content',
                display: 'flex',
                justifyContent: 'center'
            }}
        >
            {/* HTML Fijo en Inglés */}
            <div
                data-mirai-id={hotelId}
                data-locale={FIXED_LOCALE}
                style={{ display: 'none' }}
            ></div>

            <div
                data-mirai-component="finder"
                data-type="hotel"
                data-locale={FIXED_LOCALE}
                {...(isVertical ? { 'data-layout': 'vertical' } : {})}
            ></div>
        </div>
    );
};

export default MiraiBooking;